import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Page } from '@larvitu/shared/mui/ui-components';
import { Link } from '@larvitu/shared/next/mui';

import { ConsultingSection } from '../components';
import { getLayout } from '../lib/getLayout';
import { getServerTranslations } from '../lib/i18n/getServerTranslations';

import type { AppPage } from '../@types/page';
import type { GetStaticProps, InferGetStaticPropsType } from 'next';

interface ContactAddress {
  zipcode: string;
  city: string;
  street: {
    name: string;
    number: string;
  };
}

const email = process.env.NEXT_PUBLIC_NODEMAILER_RECEIVERS

// todo implement toolbarOffset
const Kontakt: AppPage<InferGetStaticPropsType<typeof getStaticProps>> = () => {
  const { t } = useTranslation( ['contact', 'common'] );

  // getting address from JSON
  const contactAddress = t( 'address', {
    returnObjects: true,
  } ) as unknown as ContactAddress;

  return (
    <Page title="Kontakt">
      <ConsultingSection
        header={
          <Typography
            variant="h2"
            fontWeight="bold"
            sx={{
              color: 'common.black',
              mb: {
                xs: 3,
                md: 8,
              },
            }}
          >
            {t( 'header', { ns: 'contact' } )}
          </Typography>
        }
        address={
          <Link href="https://goo.gl/maps/EDFtpMVQEVwLUpdn7" color="inherit">
            <Typography>
              {contactAddress.street.name} {contactAddress.street.number}, {contactAddress.zipcode}
              {' '}
              {contactAddress.city}
            </Typography>
          </Link>
        }
        email={
          <Link
            color="inherit"
            // href={`mailto:${t( 'address.email', { ns: 'contact' } )}`}
            href={`mailto:${email}`}
          >
            {/*{t( 'address.email', { ns: 'contact' } ).split( ',' )[0].trim()}*/}
            {email?.split( ',' )[0].trim()}
          </Link>
        }
      />
    </Page>
  );
};

Kontakt.getLayout = getLayout;

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => ({
  props: {
    ...(await getServerTranslations( locale, ['common', 'contact'] )),
  },
});

export default Kontakt;
